<div class="modal-div">
  <div class="popup-header">
    <span class="popup-title header-num">{{ configs.title }}</span>
    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
      (keydown.enter)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        " alt="close"
      />
    </button>
  </div>

  <div class="modal-body">
    <div class="info-section">
      <div class="info-item">
        <span class="info-label">Script Name:</span>
        <span class="info-value">{{ configs.data.scriptName }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Test Suite:</span>
        <span class="info-value">{{ configs.data.testSuite }}</span>
      </div>
      <div class="info-item info-item-full">
        <span class="info-label">Mapped Test Case:</span>
        <span class="info-value">{{ configs.data.mappedTestCase }}</span>
      </div>
    </div>

    <div class="warning-section" *ngIf="configs?.data?.showMobileDeviceWarning">
      <span class="warning-text"><span class="warning-label">Action Required:</span> No mobile device found. Add a mobile device to continue.</span>
    </div>

    <app-dynamic-form
      [form]="dynamicForm"
      [formFields]="configs.fields"
      (modelChange)="onFormChange($event)"
    ></app-dynamic-form>

    <div class="d-flex flex-row justify-content-between align-items-center py-2">
      <span class="title-text">Role-Based Credential(s)</span>
      <span (click)="addNewRow()" class="link-text" (keydown.enter)="addNewRow()">Add Credential(s) </span>
    </div>

    <app-zorro-table
      [enableHorizontalScroll]="true"
      [columns]="configs.tableData?.columns"
      [data]="configs.tableData?.rows"
      (handleActions)="handleTableActions($event)"
    >
    </app-zorro-table>
  </div>

  <div class="modal-footer d-flex justify-content-end">
    <button
      type="submit"
      class="btn btn-accello-secondary d-block"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="btn btn-accello-primary-light d-block"
      (click)="create()"
      [disabled]="!dynamicForm.valid"
    >
      {{ configs.saveBtnText }}
    </button>
  </div>
</div>
